import { cdnCommonPath } from "@/constants/cdnUrls";
import { useTranslationDetector } from "@/hooks/useTranslationDetector";
import { Link } from "@/i18n/navigation";
import { byPrefixAndName } from "@awesome.me/kit-12cf79935c/icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Image from "next/image";

export default function FooterBottom() {
  const t = useTranslationDetector();

  return (
    <section className="bg-background-global py-8 lg:py-6">
      <div className="container">
        <div className="flex flex-col-reverse items-center justify-between gap-8 lg:flex-row lg:gap-0">
          <div className="inline-flex flex-col items-center gap-4 lg:gap-0">
            <span className="lg:hidden">Trncom Turizm, Belge No: 10357</span>

            <div className="inline-flex items-center gap-2">
              <FontAwesomeIcon
                icon={byPrefixAndName.fak["turna-logo-icon"]}
                className="text-2xl"
              />
              <span>{new Date().getFullYear()} © Turna</span>
            </div>
          </div>
          <div className="inline-flex flex-col flex-wrap items-center justify-center gap-4 md:flex-row lg:justify-between lg:gap-12">
            <div className="inline-flex flex-col gap-4 sm:flex-row lg:gap-12">
              <div className="flex flex-row text-left text-sm lg:flex-col lg:text-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="86"
                  height="32"
                  viewBox="0 0 86 32"
                  fill="none"
                  className="mx-auto"
                >
                  <path
                    d="M42.8231 13.1337C42.1772 13.1542 41.5399 13.2884 40.9403 13.5304C41.2142 14.0716 41.5548 14.5193 41.9663 14.934C42.2339 15.2031 42.5195 15.4317 42.822 15.6188L42.8231 13.1337ZM31.2214 20.3275L29.4137 27.702H31.6911L33.4618 20.3275H31.2214ZM41.0143 27.702L39.4964 20.3275H37.2201L33.4258 27.702H35.6292L36.0988 26.7939H38.6724L38.8088 27.702H41.0143ZM38.4481 25.3403H36.7504L38.0515 22.652L38.4566 25.3488L38.4481 25.3403ZM49.1084 20.3275H42.5311L42.2064 22.216H44.3748L43.4355 27.702H45.6759L46.6152 22.216H48.7477L49.1084 20.3275ZM55.9024 27.702L54.3845 20.3275H52.1082L48.314 27.702H50.5184L50.988 26.7939H53.5626L53.6991 27.702H55.9024ZM53.3363 25.3403H51.6386L52.9396 22.652L53.3458 25.353L53.3363 25.3403ZM50.1397 12.2213C49.4511 14.5469 47.5175 16.3823 45.0592 17.0512C45.1512 17.6393 46.1455 18.9472 47.6095 18.9472H54.3856C54.6923 18.9472 55.0181 18.7473 55.2709 18.5112C55.5237 18.2752 55.8855 17.8392 56.0844 17.5297H49.8329C49.5442 17.5297 49.3813 17.0214 49.9588 17.0214H56.608C56.9877 17.0034 57.8551 16.1856 58.018 15.823H50.8812C50.8168 15.8188 50.7565 15.7902 50.7124 15.7429C50.6682 15.6956 50.6437 15.6332 50.6437 15.5683C50.6437 15.5035 50.6682 15.4411 50.7124 15.3938C50.7565 15.3465 50.8168 15.3178 50.8812 15.3136H58.4876C58.9213 15.2052 59.5179 14.733 59.8257 14.1152H51.9474C51.6036 14.1152 51.6036 13.6059 51.9474 13.6059H60.1864C60.801 13.4963 61.5774 12.7158 61.7762 12.2256L50.1397 12.2213ZM36.1718 17.5297H29.9193C30.1182 17.8392 30.4799 18.2752 30.7328 18.5112C30.9856 18.7473 31.3103 18.9472 31.6181 18.9472H38.3942C39.8571 18.9472 40.8514 17.6393 40.9434 17.0512C38.4862 16.3823 36.5526 14.5469 35.864 12.2213L24.2285 12.2266C24.4274 12.7169 25.2038 13.4974 25.8183 13.6069H34.0573C34.4 13.6069 34.4 14.1163 34.0573 14.1163H26.1801C26.4879 14.7341 27.0834 15.2062 27.5171 15.3147H35.1236C35.1879 15.3189 35.2483 15.3475 35.2924 15.3948C35.3365 15.4421 35.3611 15.5045 35.3611 15.5694C35.3611 15.6342 35.3365 15.6966 35.2924 15.7439C35.2483 15.7912 35.1879 15.8199 35.1236 15.8241H27.9868C28.1486 16.1877 29.017 17.0044 29.3957 17.0225H36.0449C36.6235 17.0214 36.4606 17.5297 36.1718 17.5297ZM40.7932 13.1837C41.4395 12.9264 42.126 12.786 42.821 12.769V10.4827H40.2083C40.2263 11.4291 40.4431 12.3755 40.7932 13.1837ZM38.9781 14.4183C39.4047 13.9677 39.909 13.5984 40.4664 13.3283C40.0773 12.4306 39.8667 11.4649 39.8465 10.4859H37.2084C37.2476 12.0512 37.8685 13.4251 38.9781 14.4183ZM42.6644 15.9283C42.316 15.7248 41.9953 15.4767 41.7103 15.1903C41.2696 14.7457 40.9032 14.2326 40.625 13.6707C40.1162 13.9164 39.6519 14.2428 39.2584 14.6395C40.1787 15.3711 41.394 15.8443 42.6644 15.9283ZM42.821 7.82425C42.126 7.80776 41.4394 7.66734 40.7932 7.40954C40.4271 8.264 40.2285 9.18146 40.2083 10.1116H42.821V7.82425ZM40.9403 7.06394C41.5399 7.30589 42.1772 7.44014 42.8231 7.46058L42.822 4.97652C42.5111 5.17032 42.2239 5.40017 41.9663 5.66134C41.5538 6.07499 41.2142 6.52268 40.9403 7.06394ZM40.4664 7.26492C39.909 6.99478 39.4047 6.62552 38.9781 6.17495C37.8685 7.16815 37.2476 8.5431 37.2095 10.1084H39.8476C39.8645 9.10137 40.0951 8.11987 40.4664 7.26492ZM41.7103 5.404C42.0139 5.09881 42.3154 4.87444 42.6644 4.66602C41.393 4.75002 40.1776 5.22323 39.2573 5.95483C39.6519 6.35147 40.1152 6.67687 40.624 6.92357C40.9028 6.36185 41.2696 5.8488 41.7103 5.404ZM43.1817 12.77C43.8767 12.7865 44.5632 12.9269 45.2094 13.1848C45.5755 12.3303 45.7741 11.4128 45.7944 10.4827H43.1806L43.1817 12.77ZM44.0374 14.934C44.4489 14.5193 44.7884 14.0716 45.0634 13.5304C44.4638 13.2884 43.8265 13.1542 43.1806 13.1337V15.6178C43.4831 15.4317 43.7687 15.2031 44.0374 14.934ZM48.7942 10.4859H46.1561C46.1354 11.4652 45.9248 12.4311 45.5363 13.3294C46.094 13.5995 46.5986 13.9688 47.0256 14.4193C48.1342 13.4251 48.7561 12.0512 48.7942 10.4859ZM43.3382 15.9283C44.6097 15.8443 45.824 15.3711 46.7453 14.6395C46.3469 14.2415 45.8845 13.9139 45.3776 13.6707C45.0995 14.2326 44.733 14.7457 44.2923 15.1903C44.0076 15.477 43.6868 15.725 43.3382 15.9283ZM45.2105 7.4106C44.5642 7.66791 43.8777 7.80831 43.1827 7.82532V10.1126H45.7965C45.7755 9.1825 45.5765 8.26512 45.2105 7.4106ZM44.0374 5.66134C43.7798 5.40017 43.4926 5.17032 43.1817 4.97652V7.46058C43.8275 7.44014 44.4648 7.30589 45.0645 7.06394C44.7985 6.54446 44.4518 6.07098 44.0374 5.66134ZM46.1561 10.1084H48.7942C48.7561 8.5431 48.1342 7.16815 47.0256 6.17495C46.5988 6.62578 46.0942 6.99507 45.5363 7.26492C45.9075 8.11987 46.1381 9.10137 46.1561 10.1084ZM45.3787 6.92357C45.8885 6.67687 46.3518 6.35041 46.7464 5.95483C45.825 5.22323 44.6097 4.75002 43.3382 4.66602C43.6873 4.87444 43.9887 5.09881 44.2923 5.404C44.7324 5.84637 45.0867 6.34509 45.3787 6.92357Z"
                    fill="#1D1E20"
                  />
                </svg>
                <div>
                  {t("footer.trncomtravelagency")}
                  <br />
                  <b>{t("footer.iata")} </b>
                </div>
              </div>
              <div className="flex flex-row gap-4 text-left text-sm md:text-center lg:flex-col lg:gap-0">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="40"
                  height="25"
                  viewBox="0 0 40 25"
                  fill="none"
                  className="mx-auto"
                >
                  <g clipPath="url(#clip0_16142_6383)">
                    <path
                      d="M7.5918 9.81332H10.2258V7.36035H7.5918V9.81332Z"
                      fill="#1D1E20"
                    />
                    <path
                      d="M7.5918 13.4934H10.2258V11.0391H7.5918V13.4934Z"
                      fill="#1D1E20"
                    />
                    <path
                      d="M7.5918 17.1737H10.2258V14.7207H7.5918V17.1737Z"
                      fill="#1D1E20"
                    />
                    <path
                      d="M6.72197 13.4934V11.0391H4.08789V13.4934H6.72197Z"
                      fill="#1D1E20"
                    />
                    <path
                      d="M4.08789 17.1737H6.72197V14.7207H4.08789V17.1737Z"
                      fill="#1D1E20"
                    />
                    <path
                      d="M0.564453 17.1737H3.19852V14.7207H0.564453V17.1737Z"
                      fill="#1D1E20"
                    />
                    <path
                      d="M14.6191 9.81332H17.2517V7.36035H14.6191V9.81332Z"
                      fill="#1D1E20"
                    />
                    <path
                      d="M13.7376 7.36035H11.1035V17.1737H13.7376V7.36035Z"
                      fill="#1D1E20"
                    />
                    <path
                      d="M36.5692 7.36035V11.037H32.1751V7.36035H29.541V17.1737H32.1751V13.4928H36.5692V17.1737L39.2033 17.1723V7.36035H36.5692Z"
                      fill="#1D1E20"
                    />
                    <path
                      d="M25.9148 13.8719C25.7427 14.3639 25.2473 14.7193 24.6621 14.7193H21.3501C21.0268 14.7193 20.7649 14.4754 20.7649 14.1744V10.3583C20.7649 10.0572 21.0268 9.81332 21.3501 9.81332H25.1007C25.5152 9.81332 25.8609 10.0809 25.9537 10.4391L28.3648 9.12902C27.8889 8.0893 26.7814 7.36035 25.4912 7.36035H21.2528C19.5287 7.36035 18.1309 8.66209 18.1309 10.2677V14.3025C18.1309 15.8886 19.5107 17.1737 21.2139 17.1737H25.4928C26.9161 17.1737 28.1164 16.2859 28.492 15.0719L28.5354 14.9158L25.9163 13.8733L25.9148 13.8719Z"
                      fill="#1D1E20"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_16142_6383">
                      <rect
                        width="38.64"
                        height="24.5333"
                        fill="white"
                        transform="translate(0.564453)"
                      />
                    </clipPath>
                  </defs>
                </svg>
                <div>
                  {t("footer.trncomtravelagency")}
                  <br />
                  <b>{t("footer.tch")}</b>
                </div>
              </div>
            </div>

            <div className="inline-flex gap-6 lg:gap-12">
              <Link href="https://www.tursab.org.tr/tr/ddsv" target="_blank">
                <Image
                  src={cdnCommonPath + "/tursab.png"}
                  alt=""
                  width={158}
                  height={72}
                />
              </Link>
              <Link
                href="https://etbis.ticaret.gov.tr/tr/SiteSorgulamaSonuc?siteId=2b739f32-6585-42c1-8866-451d7ffac280"
                target="_blank"
              >
                <Image
                  src={cdnCommonPath + "/etbis-qr.png"}
                  alt=""
                  width={72}
                  height={72}
                />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
